import React from 'react';

import axios from 'axios';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';

import Alert from '@material-ui/lab/Alert';

import Shared from '../AuthShared/AuthShared';
import FooterComponent from '../Shared/Component/FooterComponent';

import DialogAddComponent from './Component/DialogAddComponent';
import DialogEditComponent from './Component/DialogEditComponent';

import { Config } from '../../Config';
import '../../index.css';

const styles = theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    paper: {
        maxWidth: '80vw',
        margin: `${theme.spacing(1)}px auto`,
        padding: theme.spacing(3),
    },
    table: {
        minWidth: 650,
    },
    tableHead: {
        fontWeight: 'bold'
    },
    button: {
        width: '150px',
        fontWeight: 'bold'
    }
})

class Userview extends React.Component {
    constructor() {
        super()
        this.state = {
            data: [],
            query_data: [],

            dialog_add: false,
            dialog_edit: false,

            viewState: false,
            loading: false
        }
    }

    componentDidMount() {
        if (sessionStorage.getItem('is_admin') === "N" ||
            sessionStorage.getItem('is_admin') === null) {
            let error_msg = "Sorry, you do not have enough permission to access this page."
            this.errorHandler(error_msg)
        }
        else {
            this.fetchData()
        }
    }

    init = () => {
        window.location.reload()
    }

    fetchData = () => {
        this.setState({ loading: true })
        axios.get(Config() + '/userview/get')
            .then(response => {
                this.setState({
                    data: response.data,
                    loading: false,
                    viewState: true
                })
            })
            .catch(error => {
                console.log(error)
                this.setState({ loading: false })
                let error_msg = "Something went wrong when fetching the data."
                this.errorHandler(error_msg)
            })
    }

    openAddDialog = () => {
        this.setState({ dialog_add: true })
    }

    closeAddDialog = () => {
        this.setState({ dialog_add: false })
    }

    addHandler = (
        username, password, checkbox
    ) => {
        this.setState({ loading: true })
        axios.post(Config() + '/userview/add', {
            'username': username,
            'password': password,
            'checkbox': checkbox
        })
            .then(response => {
                if (response.data === "OK") {
                    this.init()
                }
                else if (response.data === "Exist") {
                    this.setState({
                        alert: true,
                        alertText: "User Name already exists.",
                        loading: false,
                        dialog_add: false
                    })
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({ loading: false, dialog_add: false })
                let error_msg = "Something went wrong when adding the data."
                this.errorHandler(error_msg)
            })
    }

    queryData = (user_id) => {
        this.setState({ loading: true })
        axios.put(Config() + '/userview/query', {
            'user_id': user_id
        })
            .then(response => {
                this.setState({
                    query_data: response.data,
                    loading: false,
                    dialog_edit: true
                })
            })
            .catch(error => {
                console.log(error)
                this.setState({ loading: false })
                let error_msg = "Something went wrong when fetching the data."
                this.errorHandler(error_msg)
            })
    }

    closeEditDialog = () => {
        this.setState({ dialog_edit: false })
    }

    editHandler = (
        user_id, username, password, checkbox
    ) => {
        this.setState({ loading: true })
        axios.post(Config() + '/userview/edit', {
            'user_id': user_id,
            'username': username,
            'password': password,
            'checkbox': checkbox
        })
            .then(response => {
                if (response.data === "OK") {
                    this.init()
                }
                else if (response.data === "Exist") {
                    this.setState({
                        alert: true,
                        alertText: "User Name already exists.",
                        loading: false,
                        dialog_edit: false
                    })
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({ loading: false, dialog_edit: false })
                let error_msg = "Something went wrong when updating the data."
                this.errorHandler(error_msg)
            })
    }

    deleteHandler = (user_id) => {
        this.setState({ loading: true })
        axios.post(Config() + '/userview/delete', {
            'user_id': user_id
        })
            .then(response => {
                if (response.data === "OK") {
                    this.init()
                }
            })
            .catch(error => {
                console.log(error)
                this.setState({ loading: false })
                let error_msg = "Something went wrong when deleting the data."
                this.errorHandler(error_msg)
            })
    }

    errorHandler = (error_msg) => {
        this.setState({
            alert: true,
            alertText: error_msg,
            visible: false
        })

        window.scrollTo({
            top: 100,
            left: 0,
            behavior: 'smooth'
        })
    }

    render() {
        const { classes } = this.props

        return (
            <div className="background">

                <Shared action={this.goLogin} />

                <Backdrop className={classes.backdrop}
                    open={this.state.loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>

                <Paper className={classes.paper}>
                    {this.state.alert ?
                        <Alert severity="error">
                            {this.state.alertText}
                        </Alert>
                        :
                        null
                    }

                    <br />

                    {this.state.viewState === true ?
                        <React.Fragment>

                            <Grid container direction="row" spacing={1}>
                                <Grid item xs={12} style={{ textAlign: 'center' }}>
                                    <Button variant="contained" color="primary"
                                        className={classes.button}
                                        onClick={this.openAddDialog}>
                                        Add User
                                    </Button>
                                </Grid>
                            </Grid>

                            <br />

                            <TableContainer>
                                <Table className={classes.table} size="small">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={classes.tableHead}>User Name</TableCell>
                                            <TableCell className={classes.tableHead} style={{ textAlign: 'right' }}>Admin Access</TableCell>
                                            <TableCell className={classes.tableHead} style={{ textAlign: 'right' }}>Created At</TableCell>
                                            <TableCell className={classes.tableHead} style={{ textAlign: 'right' }}>Logon Count</TableCell>
                                            <TableCell className={classes.tableHead} style={{ textAlign: 'right' }}>Last Logon At</TableCell>
                                            <TableCell className={classes.tableHead} style={{ textAlign: 'right' }}>Actions</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    {this.state.data.length === 0 ?
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={5} style={{ textAlign: 'center' }}>No data to display...</TableCell>
                                            </TableRow>
                                        </TableBody>
                                        :
                                        this.state.data.map(x => (
                                            <TableBody key={x.user_id}>
                                                <TableRow>
                                                    <TableCell>{x.user_name}</TableCell>
                                                    {x.admin_access === "Y" ?
                                                        <TableCell style={{ textAlign: 'right' }}>Yes</TableCell>
                                                        :
                                                        <TableCell style={{ textAlign: 'right' }}>No</TableCell>
                                                    }
                                                    <TableCell style={{ textAlign: 'right' }}>{x.created_at}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>{x.logon_count}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>{x.last_logon}</TableCell>
                                                    <TableCell style={{ textAlign: 'right' }}>
                                                        {x.user_name === "superuser" ?
                                                            null
                                                            :
                                                            <React.Fragment>
                                                                <Button
                                                                    color="primary"
                                                                    style={{ fontWeight: 'bold' }}
                                                                    onClick={() => this.queryData(x.user_id)}>
                                                                    Edit
                                                                </Button>
                                                                <Button
                                                                    color="secondary"
                                                                    style={{ fontWeight: 'bold' }}
                                                                    onClick={() => this.deleteHandler(x.user_id)}>
                                                                    Delete
                                                                </Button>
                                                            </React.Fragment>}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))
                                    }
                                </Table>
                            </TableContainer>
                        </React.Fragment>
                        :
                        null
                    }

                </Paper>

                {this.state.dialog_add ?
                    <DialogAddComponent
                        open={this.state.dialog_add}
                        onClose={this.closeAddDialog}
                        action={this.addHandler}
                    />
                    :
                    null
                }

                {this.state.dialog_edit ?
                    <DialogEditComponent
                        open={this.state.dialog_edit}
                        onClose={this.closeEditDialog}
                        data={this.state.query_data}
                        action={this.editHandler}
                    />
                    :
                    null
                }

                <FooterComponent />

            </div>
        )
    }
}

export default withStyles(styles, { withTheme: true })(Userview);